<nav #navbar class="navbar active">
  <div class="container-fluid">
    <div class="navbar-header">
      <a
        href="#"
        onClick="return false;"
        class="navbar-toggle collapsed"
        (click)="isNavbarCollapsed = !isNavbarCollapsed"
        aria-expanded="false"
      ></a>
      <a
        href="#"
        onClick="return false;"
        class="bars"
        (click)="mobileMenuSidebarOpen($event, 'overlay-open')"
      ></a>
      <div class="dashboard-logo-container d-flex" [ngClass]="isSidebarCollapsed ? 'collapsed-logo' : 'expanded-logo'">
        <a class="" routerLink="{{ homePage }}">
          <!-- <img src="./../../../assets/easy_assets/favicon@2x.png" alt=""  style="height: 45px;"/> -->
          <!-- @if(isNavbarCollapsed){
      
      
              }@else{
      
              } -->
          <img src="./../../../assets/easy_assets/dashboard logo.png" alt="" class="dashboard_logo_icon" />
          <!-- esyID Card Solutions -->
      
          <!-- <span class="logo-name">Easy ID</span> -->
        </a>
      </div>
      
    </div>
    <div
      class="collapse navbar-collapse"
      [ngClass]="isNavbarCollapsed ? '' : 'show'"
    >
      <ul class="float-start collapse-menu-icon">
        <li class="hamburger-li" [ngClass]="isSidebarCollapsed ? 'collapsed-hamburger' : 'expanded-hamburger'">
          <button (click)="callSidemenuCollapse()" class="btn sidemenu-collapse">
            <!-- <i
                                class="material-icons-outlined icon-color">
                                menu
                              </i> -->
            <img src="./../../../assets/images/icons/Hamburger-icon-img.svg" />
          </button>
        </li>
      </ul>
      <ul class="nav navbar-nav navbar-right">
        <!-- Full Screen Button -->
        <li class="fullscreen">
          <!-- {{isNavbarCollapsed}} -->
          <button
            class="btn nav-notification-icons"
            (click)="callFullscreen()"
          >
            <img src="../../../assets/images/icons/full-screen-svgrepo-com.svg" class="full_screen_icon_img">
          </button>
        </li>
        <!-- #END# Full Screen Button -->
        <!-- #START# Notifications-->
        <!-- <li>
          <button mat-button [matMenuTriggerFor]="notificationMenu" class="nav-notification-icons"> <i
              class="material-icons-outlined icon-color">
              notifications_active
            </i></button>
          <mat-menu #notificationMenu="matMenu" class="nfc-menu">
            <div class="nfc-header">
              <h5 class="mb-0">Notitications</h5>
              <a class="nfc-mark-as-read">Mark all as read</a>
            </div>
            <div class="nfc-dropdown">
              <ng-scrollbar style="height: 350px" visibility="hover">
                <div class="noti-list header-menu">
                  <div class="menu">
                    <div>
                      @for (notification of notifications; track notification) {
                      <button mat-menu-item onClick="return false;" [ngClass]="[notification.status]">
                        <span class="table-img msg-user ">
                          <i class="material-icons-outlined nfc-type-icon"
                            [ngClass]="[notification.color]">{{notification.icon}}</i>
                        </span>
                        <span class="menu-info">
                          <span class="menu-title">{{notification.message}}</span>
                          <span class="menu-desc mt-2">
                            <i class="material-icons">access_time</i> {{notification.time}}
                          </span>
                        </span>
                        <span class="nfc-close">
                          <app-feather-icons [icon]="'x'" [class]="'user-menu-icons'"></app-feather-icons>
                        </span>
                      </button>
                      }
                    </div>
                  </div>
                </div>
              </ng-scrollbar>
            </div>
            <div class="nfc-footer">
              <a class="nfc-read-all">Read
                All Notifications</a>
            </div>
          </mat-menu>
        </li> -->
        <!-- #END# Notifications-->
        <!-- <li class="nav-item">
          <button mat-button [matMenuTriggerFor]="languagemenu" class="lang-dropdown nav-notification-icons"> @if
            (flagvalue !== undefined) {
            <img src="{{flagvalue}}" height="16">
            }
            @if (flagvalue === undefined) {
            <img src="{{defaultFlag}}" height="16">
            }</button>
          <mat-menu #languagemenu="matMenu">
            @for (item of listLang; track item) {
            <div class="lang-item">
              <button mat-menu-item class="dropdown-item lang-item-list"
                (click)="setLanguage(item.text, item.lang, item.flag)"
                [ngClass]="{'active': langStoreValue === item.lang}">
                <img src="{{item.flag}}" class="flag-img" height="12"> <span class="align-middle">{{item.text}}</span>
              </button>
            </div>
            }
          </mat-menu>
        </li> -->

        @if(notificationIconHidden==false)
        {
        <li>
          <button [matMenuTriggerFor]="notificationMenu" class="btn nav-notification-icons" (click)="bellClick()">
            <img src="../../../assets/images/icons/Union 121.svg" class="notification_icon_img">
            @if(unreadCount > 0){
            <span class="badge bg-red notification-badge">
              {{unreadCount > 99 ? "99+" : unreadCount}}
            </span>
            }
          </button>
          <mat-menu #notificationMenu="matMenu" class="nfc-menu" xPosition="before" [hasBackdrop]="true">
            <div class="nfc-header" (click)="$event.stopPropagation()">
              <h5 class="mb-0">Notifications</h5>
              <!-- <a (click)="openNotificationSettingModal()" class="nfc-mark-as-read"><i
                                  class="material-icons-outlined icon-color">
                                  settings
                                </i></a> -->
              <div></div>
            </div>
            <div class="row p-2 btn-heading" (click)="$event.stopPropagation()">
              @if(this.notificationTotalItemCount > 0) {
              <div class="col-md-6 mb-3">
                <a (click)="markAllNoficationsAsRead()" class="btn btn-sm btn-outline-primary">Mark All As Read</a>
              </div>
              }
              <div class="col-md-6">
                <!-- (change)="showRead($event)" -->
                <!-- <form [formGroup]="notificationForm">
                                  <mat-slide-toggle formControlName="isUnread" (change)="showUnreadRead($event)"><span style="font-size: 11px;" >{{'NOTIFICATION_MENU.SHOW_ONLY_UNREAD' | translate}}</span></mat-slide-toggle>
                                </form> -->
              </div>
            </div>
            @if(this.notificationTotalItemCount === 0) {
            <div class="text-center">
              <p><b>Oops! No notifications yet</b></p>
            </div>
            } @else {
            <div class="nfc-dropdown">
              <ng-scrollbar style="height: 350px" visibility="hover">
                <div class="noti-list header-menu">
                  <div class="menu">
                    <div (scroll)="onScroll($event)" class="item-container">
                      @for (notification of notificationList; track
                      notification.id) {
                      <button mat-menu-item onClick="return false;" [ngClass]="{ 'msg-unread': !notification.isRead }"
                        (click)="handleNotification(notification)">
                        <span class="table-img msg-user">
                          <i class="material-icons-two-tone nfc-type-icon" [ngClass]="{ 'nfc-green': true }">{{
                            "notifications_active" }}</i>
                        </span>
                        <span class="menu-info">
                          <span class="menu-title">{{
                            notification.title
                            }}</span>
                          <span class="menu-desc mt-2">
                            <span class="">{{ notification.message }}</span>
                            <br />
                            <i class="material-icons">access_time</i>
                            {{ getFromNow(notification?.timestamp) }} ago
                          </span>
                        </span>
                        <span class="nfc-close"> </span>
                      </button>
                      }
                    </div>
                    <!-- <app-loader *ngIf=""></app-loader> -->
                  </div>
                </div>
              </ng-scrollbar>
            </div>
            }
            <!-- <div class="nfc-footer">
                              <a class="nfc-read-all">{{'NOTIFICATION_MENU.READ_ALL_NOTIFICATIONS' | translate}}</a>
                            </div> -->
          </mat-menu>
        </li>
        }
        

        <li class="nav-item user_profile">
          <div class="user_img_dropdown d-flex">
            <button [matMenuTriggerFor]="profilemenu" class="btn user_img_btn">
              <div class="chip dropdown-toggle " ngbDropdownToggle>
          
                <img src="{{ userImg }}" class="user_img" alt="User" />
          
              </div>
            </button>
          </div>
          <mat-menu #profilemenu="matMenu" class="profile-menu">
            <div class="noti-list">
              <div class="menu">
                <div class="user_dw_menu">
                  <!-- <button mat-menu-item class="user-item-list">
                    <app-feather-icons [icon]="'user'" [class]="'user-menu-icons'"></app-feather-icons>Account
                  </button>
                  <button mat-menu-item class="user-item-list">
                    <app-feather-icons [icon]="'mail'" [class]="'user-menu-icons'"></app-feather-icons>Inbox
                  </button>
                  <button mat-menu-item class="user-item-list">
                    <app-feather-icons [icon]="'settings'" [class]="'user-menu-icons'"></app-feather-icons>Settings
                  </button> -->
                  <button
                    mat-menu-item
                    class="user-item-list"
                    (click)="enable2FA()"
                  >
                    <img src="../../../assets/images/icons/Manage Configarations.svg" alt="">
                    &nbsp;Enable 2FA
                  </button>
                  <button
                    mat-menu-item
                    (click)="logout()"
                    class="user-item-list"
                  >
                  <img src="../../../assets/images/icons/Logout.svg" alt="">
                    &nbsp;Logout
                  </button>
                </div>
              </div>
            </div>
          </mat-menu>
        </li>
        <!-- #END# Tasks -->
      </ul>
    </div>
  </div>
</nav>

<app-twofa-modal></app-twofa-modal>
